import { render, staticRenderFns } from "./FormularioPreciosHora.vue?vue&type=template&id=6032d4b1"
import script from "./FormularioPreciosHora.vue?vue&type=script&lang=js"
export * from "./FormularioPreciosHora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports